import { useSelector } from 'react-redux';
import { selectServices } from 'redux-store/features/services/services.selectors';

export const useServices = () => useSelector(selectServices);
